import Vue from 'vue';
import axios from 'axios';

const ReadingTypes = ["undefined", "Actual", "Estimated (non reversible)", "Estimated (reversible)",];


export default {
  name: 'CmrContrPnlEditReading_History',
  components: {
    DxBarChart: require("@/components/charts/dxCharts/dxBarChart.vue").default,
    DxLineChart: require("@/components/charts/dxCharts/dxLineChart.vue").default,
  },
  props: {
    editingReading: {
      type: Object,
      required: true
    },
    history: {
      type: Array,
      required: true
    },
    isPropertyOriented: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dxBarChartData: [],
      dxBarChartOptions: [],
      dxLineChartData: [],
      dxLineChartOptions: [],
      showCharts: false,
      openItem: [true, false, false],
    }
  },
  computed: {},
  watch: {
    openItem: function (val) {
      this.saveFilterToLocal();
    },
  },
  created() {
    this.$root.$on('history_window_init', () => { this.showCharts = true; });
    this.init();
  },  
  methods: {
    init() {
      this.getFilterFromLocal();
      let obj = { description: "" };
      let arr = [];
      let arr1 = [];
      let iConsumptionSum = 0;
      let iConsumptionCount = 0;

      this.history.forEach((item) => {
        obj[item.period] = item.consumption;
        arr.unshift({ valueField: item.period, name: item.period });
        arr1.unshift({ argumentField: item.period, value: item.consumption });
        iConsumptionSum = iConsumptionSum + item.consumption;
        iConsumptionCount++;
      });

      let iAvg = iConsumptionCount > 0 ? iConsumptionSum / iConsumptionCount : 0;
      let title = this.editingReading.tenantName;
      let subtitle = "Avg: " + iAvg.toFixed(2).toString();

      this.dxBarChartData = [obj];
      this.dxBarChartOptions = {
        title: title,
        subtitle: subtitle,
        dataOptions: arr,
      };

      this.dxLineChartData = arr1;
      this.dxLineChartOptions = [
        { value: "value", name: this.$t("captureMR.ColConsumption") },
      ];
    },
    getFilterFromLocal() {
      let opnItem = this.$localStorage.get('_cmr_control_panel_edit_reading_history');
      
      if (opnItem) {
        try {
          let temp = opnItem.split(',');
          this.openItem.length = 0;
          temp.forEach(t => this.openItem.push(t == 'true'));
        }
        catch (err) {
          this.openItem = [true, false, false];
        };
      }
    },
    saveFilterToLocal() {
      this.$localStorage.set('_cmr_control_panel_edit_reading_history', this.openItem.toString());
    },
    getTypeDescr(item) {
      if (item == 0)
        return ReadingTypes[1];
      if (item == 1)
        return ReadingTypes[2];
      if (item == 2)
        return ReadingTypes[3];        
      else
        return ReadingTypes[0];
    }
  }
}
